  // Import the functions you need from the SDKs you need
  import { initializeApp } from "firebase/app";
  import { getFirestore } from "firebase/firestore";
  import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const firebaseConfig = {
  apiKey: "AIzaSyADJ176xDJwSHoE2mlwNNLfGEXwzf-RvtU",
  authDomain: "esa5-1ee89.firebaseapp.com",
  projectId: "esa5-1ee89",
  storageBucket: "esa5-1ee89.firebasestorage.app",
  messagingSenderId: "597760702872",
  appId: "1:597760702872:web:40d833221416e0011253ed",
  measurementId: "G-FJN2FDS880"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);
export const storage = getStorage(app);
